<template>
  <div class="container mt-4">
    <h3>Session Status</h3>
    <div class="card">
      <div class="card-body">
        <p><strong>Authenticated:</strong> {{ isAuthenticated ? 'Yes' : 'No' }}</p>
        <p><strong>User:</strong> {{ user || 'Not logged in' }}</p>
        <p><strong>Is Admin:</strong> {{ isAdmin ? 'Yes' : 'No' }}</p>
        <p><strong>Is Teacher:</strong> {{ isTeacher ? 'Yes' : 'No' }}</p>
        <p><strong>Last Session Check:</strong> {{ lastSessionCheck ? new Date(lastSessionCheck).toLocaleString() : 'Never' }}</p>
        
        <div class="mt-3">
          <button @click="checkSessionNow" class="btn btn-primary me-2" :disabled="checkingSession">
            {{ checkingSession ? 'Checking...' : 'Check Session Now' }}
          </button>
          
          <button @click="logoutNow" class="btn btn-danger" :disabled="!isAuthenticated">
            Logout
          </button>
        </div>
        
        <div v-if="sessionMessage" class="alert alert-info mt-3">
          {{ sessionMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sessionManager from '../sessionManager';
import store from '../store';

export default {
  name: 'SessionStatusItem',
  data() {
    return {
      checkingSession: false,
      sessionMessage: '',
      lastSessionCheck: null,
    };
  },
  computed: {
    isAuthenticated() {
      return store.getters.isAuthenticated;
    },
    user() {
      return store.state.user;
    },
    isAdmin() {
      return store.getters.isAdmin;
    },
    isTeacher() {
      return store.getters.isTeacher;
    },
  },
  methods: {
    async checkSessionNow() {
      this.checkingSession = true;
      this.sessionMessage = '';
      
      try {
        const isValid = await sessionManager.validateSession();
        this.lastSessionCheck = Date.now();
        this.sessionMessage = isValid ? 'Session is valid!' : 'Session has expired!';
        
        if (!isValid) {
          // If session expired, redirect to login after a short delay
          setTimeout(() => {
            this.$router.push('/login');
          }, 2000);
        }
      } catch (error) {
        this.sessionMessage = 'Error checking session: ' + error.message;
      } finally {
        this.checkingSession = false;
      }
    },
    
    async logoutNow() {
      try {
        await store.dispatch('logout');
        this.sessionMessage = 'Logged out successfully!';
        setTimeout(() => {
          this.$router.push('/login');
        }, 1000);
      } catch (error) {
        this.sessionMessage = 'Error logging out: ' + error.message;
      }
    },
  },
  mounted() {
    // Check session status on component mount
    this.lastSessionCheck = Date.now();
  },
};
</script>

<style scoped>
.card {
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
</style>